import { useGetEmailRule, useGetPhoneRule, useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { GeneralSettingsFields } from '../helpers';

export const useGeneralSettingsFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const email = useGetEmailRule({ t });
  const phoneRule = useGetPhoneRule({ t });

  return {
    [GeneralSettingsFields.SUPPORT_EMAIL]: [requiredRule, email],
    [GeneralSettingsFields.SUPPORT_PHONE_NUMBER]: [requiredRule, phoneRule],
    [GeneralSettingsFields.ORGANIZATION]: [requiredRule],
  };
};
